module.exports = __webpack_public_path__ + "img/T2D_xh_5.bc394404.png";